var _path, _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTestIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_9866_32356)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_9866_32356",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 1.90735e-06H24V24H0V1.90735e-06Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_9866_32356)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.0312 12C19.0312 15.8833 15.8833 19.0312 12 19.0312C8.11673 19.0312 4.96875 15.8833 4.96875 12C4.96875 8.11673 8.11673 4.96875 12 4.96875C15.8833 4.96875 19.0312 8.11673 19.0312 12Z",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.5156 9.89062L11.2969 14.1094L8.48438 11.2969",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.0881 1.03887C11.6137 0.591213 12.3863 0.591213 12.9119 1.03887L14.7392 2.6516L17.8315 2.41231C18.5198 2.35906 19.145 2.81323 19.307 3.48429L19.927 6.05192L22.6288 7.6692C23.2169 8.0307 23.4557 8.7656 23.1924 9.40371L22.125 11.9901L23.1924 14.5766C23.4557 15.2147 23.2169 15.9496 22.6288 16.3111L19.927 17.9284L19.307 20.496C19.145 21.167 18.5198 21.6213 17.8315 21.568L14.7695 21.331L12.9119 22.9611C12.3863 23.4088 11.6137 23.4088 11.0881 22.9611L9.23053 21.331L6.16847 21.568C5.48015 21.6213 4.85498 21.167 4.69298 20.496L4.07053 17.9182L1.37325 16.3111C0.785062 15.9496 0.546281 15.2147 0.809672 14.5766L1.87701 11.9901L0.809672 9.40371C0.546281 8.7656 0.785062 8.0307 1.37325 7.6692L3.83934 6.20412L4.69298 3.48429C4.85498 2.81323 5.48015 2.35906 6.16847 2.41231L9.26081 2.6516L11.0881 1.03887Z",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_9866_32356"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTestIcon);
export default __webpack_public_path__ + "static/media/TestIcon.3e1aa69fdad98f1435980e50a905e68f.svg";
export { ForwardRef as ReactComponent };